import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { CallCenterViewModel } from 'src/app/model/CallCenterViewModel';
import { CallCenterService } from 'src/app/services/call-center.service';
import { CallCenterTransactionModalComponent } from './transaction-modal/transaction-modal.component';

@Component({
  selector: 'app-secure-call-center-view',
  templateUrl: './call-center-view.component.html',
  styleUrls: ['./call-center-view.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CallCenterViewComponent implements OnInit {
  data: CallCenterViewModel;
  registrationId: number;
  applicationId: number;
  isLoading: boolean = false;
  
  constructor(private route: ActivatedRoute, private callCenterService: CallCenterService, private modalCtrl: ModalController) { }

  ngOnInit(): void { 
    this.route.params.subscribe((params: Params) => {
      this.registrationId = +params["registrationId"];
      this.applicationId = +params["applicationId"];
      
      this.isLoading = true;
      this.callCenterService.fetchCallCenterView(this.registrationId).subscribe(async (data: any)=>{
        this.isLoading = false;
        if(data.status === 'SUCCESS') {
          this.data = data;
          if(this.applicationId) {
            this.viewTransactions(this.applicationId);
          }
        }
        else {
          this.callCenterService.errorToast(data.errorMessage);
        }
      }, error => {
        this.isLoading = false;
        this.callCenterService.errorToast(error?.error?.errorMessage||error?.error?.message);
      });
    });
  }

  async viewTransactions(applicationId: number) {
    let viewApplicationTransactions = this.data.applicationList.find(a => a.applicationId === applicationId);
    const modal = await this.modalCtrl.create({
      component: CallCenterTransactionModalComponent,
      cssClass: 'master-modal',
      componentProps: {
        viewApplicationTransactions: viewApplicationTransactions
      }
    });
    modal.present();
  }

  showStatusClass(status: string) {
    let statusClass = 'text-white p-1 pl-2 pr-2 text-sm border-round';
    if(status === 'Verified' || status === 'Answered') {
      return statusClass + ' bg-green-400';
    }
    else if(status === 'Not Applicable') {
      return statusClass + ' surface-700';
    }
    else if(status?.indexOf('Pending') >= 0) {
      return statusClass + ' bg-orange-400';
    }
    else {
      return statusClass + ' bg-orange-400';
    }
  }

  viewDocuments(file: string) {
    
  }
}
